import React from "react";
import {Row, Col } from 'antd';
import StatusTag from "../statusTag";

const ApplicationStatusOverview = (props) =>{
    return(
        <Row gutter={32} className="mt-2">
          <Col span={24}>
            <div className="application-id-wrapper">
              <span className="businessKey">{props.id}</span>
              <StatusTag status={props.activeTaskName}/>
            </div>
          </Col>
        </Row>
    )
}

export default ApplicationStatusOverview;